import React, { useState } from "react"
import { ReactComponent as DocumentIcon } from '../../../../assets/img/icons/document.svg'
import { useDispatch } from "react-redux"
import { apiV2, wrapResponse } from "../../../../repositories/repository"
import { setSuccessMsg } from "../../../../store/Auth/action"
import { fetchError } from "../../../../store/Accounts/action"
import classNames from "classnames"
import useTranslate from "../../../../hooks/useTranslate";

interface IProps {
  patientId: string
}

const BloodTestRequisitionForm: React.FC<IProps> = ({ patientId }): JSX.Element => {
  const translateLocalazy = useTranslate()
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = async () => {
    if (isLoading) return
    setIsLoading(true)
    const res = await wrapResponse(
      apiV2.integration.createGiddirTestOrder({ patientId })
    )
    if (res.success) {
      dispatch(setSuccessMsg(translateLocalazy('blood-results.requisition-sent')))
    } else {
      dispatch(fetchError(res.error))
    }
    setIsLoading(false)
  }

  const buttonClassName = classNames([
    't_uppercase g_btn',
    {
      'g_btn--disabled': isLoading,
      'g_btn--primary': !isLoading
    }
  ])


  return (
    <div className="card-box flex flex-column" style={{ overflow: 'initial' }}>
      <div className="box-title flex flex--wrap justify-between align-center" style={{ marginBottom: 0 }}>
        <div className="flex align-center">
          <i className="icon-holder patients-detail_icon-holder">
            <DocumentIcon />
          </i>
          <h3>{translateLocalazy('blood-results.send-requisition')}</h3>
        </div>
        <button
          onClick={handleSubmit}
          className={buttonClassName}
          type="button"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span
                className="loader"
                style={{
                  marginRight: '8px',
                  transform: 'scale(0.5)',
                  transformOrigin: 'center center'
                }}
              />
              {translateLocalazy('Sending...')}
            </>
          ) : (
            translateLocalazy('Send')
          )}
        </button>
      </div>
    </div>
  )
}

export default BloodTestRequisitionForm
